export default __webpack_public_path__ + "static/media/orsettoTtsIt_It60.d1d2229b.mp3";